import { TimelineBlockProps } from "../../../ui/organisms/TimelineBlock"
import { TimelineItem } from "../../../ui/organisms/TimelineBlock/types"

export const toTimelineBlockProps = (content: any): TimelineBlockProps => {
  return {
    title: content.data.contents?.title,
    items: content.data.contents?.items.map(
      (x: any) =>
        ({
          title: x.title,
          body: x.body,
          caption: x.caption,
          image: x.image,
        } as TimelineItem)
    ),
  }
}
